export default __webpack_public_path__ + "static/12-f16e9899c76735cd90d46b75064a70a2.jpg";